// Automatisch erzeugt von scripts/gen-berufe-kurz.ts. Nicht von Hand bearbeiten.
import type { BerufKurz } from './types';

export const BERUFE: BerufKurz[] = [
  {
    "slug": "ki-engineer",
    "name": "AI / KI Engineer",
    "kurz": "AI / KI Engineer",
    "icon": "BrainCircuit",
    "bereich": "Data & KI",
    "title": "AI / KI Engineer: Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein KI Engineer? Aufgaben, Abgrenzung zu ML Engineer und Data Scientist, Gehalt nach Erfahrung, Einstieg und Karriere. Mit Zahlen für 2026.",
    "intro": [
      "KI Engineers bauen Anwendungen, die künstliche Intelligenz im Alltag nutzbar machen: Assistenten, die Kundenanfragen beantworten, Systeme, die Dokumente auswerten, oder Werkzeuge, die interne Abläufe automatisieren. Sie verbinden große Sprachmodelle und andere KI-Systeme mit den Daten und Prozessen eines Unternehmens und sorgen dafür, dass das Ergebnis zuverlässig, sicher und bezahlbar läuft."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior",
          "jahre": "0–2 Jahre",
          "min": 55000,
          "max": 68000
        },
        {
          "label": "Mid-Level",
          "jahre": "3–5 Jahre",
          "min": 68000,
          "max": 90000
        },
        {
          "label": "Senior",
          "jahre": "6–10 Jahre",
          "min": 88000,
          "max": 112000
        },
        {
          "label": "Lead / Principal",
          "min": 110000,
          "max": 140000
        }
      ]
    }
  },
  {
    "slug": "product-manager",
    "name": "Product Manager",
    "kurz": "Product Manager",
    "icon": "Route",
    "bereich": "Produkt & Design",
    "title": "Product Manager: Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein Product Manager in der IT? Aufgaben, Abgrenzung zum Product Owner, Gehalt nach Erfahrung, Einstieg und Karriere. Mit Zahlen für 2026.",
    "intro": [
      "Product Manager entscheiden, was ein digitales Produkt können soll und warum. Sie sprechen mit Kunden, werten Daten aus, setzen Prioritäten und sorgen dafür, dass Entwicklung, Design und Vertrieb am selben Ziel arbeiten. Programmieren müssen sie dafür nicht, aber sie müssen verstehen, was technisch möglich ist und was es kostet."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior",
          "jahre": "0–2 Jahre",
          "min": 48000,
          "max": 60000
        },
        {
          "label": "Mid-Level",
          "jahre": "3–5 Jahre",
          "min": 60000,
          "max": 80000
        },
        {
          "label": "Senior",
          "jahre": "6–10 Jahre",
          "min": 80000,
          "max": 105000
        },
        {
          "label": "Lead / Head of Product",
          "min": 100000,
          "max": 140000
        }
      ]
    }
  },
  {
    "slug": "cto",
    "name": "Chief Technology Officer (CTO)",
    "kurz": "CTO",
    "icon": "Crown",
    "bereich": "Leitung & Organisation",
    "title": "CTO (Chief Technology Officer): Aufgaben, Gehalt, Weg 2026 | djiiga",
    "description": "Was macht ein CTO? Aufgaben im Start-up und im Konzern, Gehalt nach Unternehmensgröße und Stadt, Weg zum CTO. Mit Zahlen für 2026.",
    "intro": [
      "Der Chief Technology Officer, kurz CTO, verantwortet die Technologie eines Unternehmens: welche Systeme gebaut werden, wie die Technik-Teams aufgestellt sind und wie Technologie zum Geschäftserfolg beiträgt. In der Regel ist der CTO Teil der Geschäftsführung oder berichtet direkt an sie."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Start-up",
          "jahre": "plus Beteiligung",
          "min": 90000,
          "max": 130000
        },
        {
          "label": "Mittelstand / Scale-up",
          "min": 120000,
          "max": 180000
        },
        {
          "label": "Großer Mittelstand / Series C+",
          "min": 160000,
          "max": 250000
        },
        {
          "label": "Konzern",
          "jahre": "plus Bonus",
          "min": 220000,
          "max": 400000
        }
      ]
    }
  },
  {
    "slug": "frontend-developer",
    "name": "Frontend Developer",
    "kurz": "Frontend Developer",
    "icon": "CodeXml",
    "bereich": "Software",
    "title": "Frontend Developer: Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein Frontend Developer? Aufgaben, Frameworks, Gehalt nach Erfahrung und Skills, Einstieg und Karriere. Mit Zahlen für 2026.",
    "intro": [
      "Frontend Developer bauen alles, was Nutzer im Browser sehen und anklicken: Oberflächen, Formulare, Dashboards, ganze Webanwendungen. Sie sorgen dafür, dass eine Anwendung schnell lädt, auf jedem Gerät funktioniert, für alle Menschen bedienbar ist und sich gut anfühlt."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior",
          "jahre": "0–2 Jahre",
          "min": 42000,
          "max": 55000
        },
        {
          "label": "Mid-Level",
          "jahre": "3–5 Jahre",
          "min": 55000,
          "max": 70000
        },
        {
          "label": "Senior",
          "jahre": "6–10 Jahre",
          "min": 70000,
          "max": 90000
        },
        {
          "label": "Lead / Staff",
          "min": 88000,
          "max": 110000
        }
      ]
    }
  },
  {
    "slug": "backend-developer",
    "name": "Backend Developer",
    "kurz": "Backend Developer",
    "icon": "ServerCog",
    "bereich": "Software",
    "title": "Backend Developer: Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein Backend Developer? Aufgaben, Programmiersprachen, Gehalt nach Erfahrung und Stadt, Einstieg und Karriere. Mit Zahlen für 2026.",
    "intro": [
      "Backend Developer bauen den Teil einer Software, den Nutzer nicht sehen: die Logik auf dem Server, die Datenbanken und die Schnittstellen, über die Apps, Websites und andere Systeme Daten austauschen. Wenn Sie in einer App eine Bestellung abschicken, kümmert sich das Backend darum, dass sie geprüft, gespeichert, bezahlt und weitergeleitet wird."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior",
          "jahre": "0–2 Jahre",
          "min": 48000,
          "max": 62000
        },
        {
          "label": "Mid-Level",
          "jahre": "3–5 Jahre",
          "min": 60000,
          "max": 78000
        },
        {
          "label": "Senior",
          "jahre": "6–10 Jahre",
          "min": 78000,
          "max": 98000
        },
        {
          "label": "Lead / Staff Engineer",
          "min": 95000,
          "max": 120000
        }
      ]
    }
  },
  {
    "slug": "devops-cloud-engineer",
    "name": "DevOps & Cloud Engineer",
    "kurz": "DevOps & Cloud Engineer",
    "icon": "CloudCog",
    "bereich": "Cloud & Infrastruktur",
    "title": "DevOps & Cloud Engineer: Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein DevOps oder Cloud Engineer? Aufgaben, Skills, Gehalt nach Erfahrung und Stadt, Einstieg und Karriere. Mit Zahlen für 2026.",
    "intro": [
      "DevOps und Cloud Engineers sorgen dafür, dass Software schnell, sicher und zuverlässig vom Rechner der Entwickler in den Betrieb kommt und dort stabil läuft. Sie automatisieren Infrastruktur, bauen Deployment-Pipelines und betreiben Systeme in der Cloud, meist auf AWS, Azure oder Google Cloud."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior",
          "jahre": "0–2 Jahre",
          "min": 50000,
          "max": 62000
        },
        {
          "label": "Mid-Level",
          "jahre": "3–5 Jahre",
          "min": 62000,
          "max": 80000
        },
        {
          "label": "Senior",
          "jahre": "6–10 Jahre",
          "min": 78000,
          "max": 98000
        },
        {
          "label": "Lead / Principal",
          "min": 95000,
          "max": 120000
        }
      ]
    }
  },
  {
    "slug": "mobile-developer",
    "name": "Mobile Developer (iOS/Android)",
    "kurz": "Mobile Developer",
    "icon": "Smartphone",
    "bereich": "Software",
    "title": "Mobile Developer (iOS/Android): Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein Mobile Developer? iOS, Android und Cross-Platform, Gehalt nach Erfahrung, Einstieg und Karriere. Mit Zahlen für 2026.",
    "intro": [
      "Mobile Developer entwickeln Apps für Smartphones und Tablets, von der Banking-App über Mobilitätsdienste bis zur Gesundheits-App. Sie arbeiten entweder nativ für eine Plattform, also iOS mit Swift oder Android mit Kotlin, oder mit Cross-Platform-Frameworks wie Flutter und React Native, die beide Plattformen aus einer Codebasis bedienen."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior",
          "jahre": "0–2 Jahre",
          "min": 45000,
          "max": 58000
        },
        {
          "label": "Mid-Level",
          "jahre": "3–5 Jahre",
          "min": 58000,
          "max": 75000
        },
        {
          "label": "Senior",
          "jahre": "6–10 Jahre",
          "min": 75000,
          "max": 95000
        },
        {
          "label": "Lead / Staff",
          "min": 92000,
          "max": 115000
        }
      ]
    }
  },
  {
    "slug": "data-scientist",
    "name": "Data Scientist",
    "kurz": "Data Scientist",
    "icon": "ChartScatter",
    "bereich": "Data & KI",
    "title": "Data Scientist: Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein Data Scientist? Aufgaben, Abgrenzung zu Data Analyst und ML Engineer, Gehalt nach Erfahrung, Einstieg und Karriere. Mit Zahlen für 2026.",
    "intro": [
      "Data Scientists gewinnen aus Daten Antworten, auf die ein Unternehmen Entscheidungen stützen kann: Welche Kunden wahrscheinlich kündigen, wie viel Ware nächste Woche gebraucht wird, welcher Preis den meisten Umsatz bringt. Dafür nutzen sie Statistik, Programmierung und Machine Learning."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior",
          "jahre": "0–2 Jahre",
          "min": 50000,
          "max": 62000
        },
        {
          "label": "Mid-Level",
          "jahre": "3–5 Jahre",
          "min": 62000,
          "max": 82000
        },
        {
          "label": "Senior",
          "jahre": "6–10 Jahre",
          "min": 82000,
          "max": 105000
        },
        {
          "label": "Lead / Principal",
          "min": 100000,
          "max": 130000
        }
      ]
    }
  },
  {
    "slug": "it-security-specialist",
    "name": "IT Security Specialist",
    "kurz": "IT Security Specialist",
    "icon": "ShieldCheck",
    "bereich": "Security",
    "title": "IT Security Specialist: Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein IT Security Specialist? Rollen von SOC bis Pentest, Gehalt nach Erfahrung und Stadt, Einstieg und Zertifikate. Mit Zahlen für 2026.",
    "intro": [
      "IT Security Specialists schützen Unternehmen vor Angriffen, Datenverlust und Ausfällen. Sie erkennen Schwachstellen, bevor Angreifer sie nutzen, überwachen Systeme auf verdächtige Aktivitäten und reagieren, wenn doch etwas passiert. Seit Ransomware-Angriffe ganze Unternehmen lahmlegen und neue Gesetze wie NIS2 mehr Pflichten bringen, gehört IT-Sicherheit zu den gefragtesten Bereichen der IT."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior",
          "jahre": "0–2 Jahre",
          "min": 50000,
          "max": 62000
        },
        {
          "label": "Mid-Level",
          "jahre": "3–5 Jahre",
          "min": 62000,
          "max": 82000
        },
        {
          "label": "Senior",
          "jahre": "6–10 Jahre",
          "min": 80000,
          "max": 100000
        },
        {
          "label": "Lead / Architect",
          "min": 98000,
          "max": 125000
        }
      ]
    }
  },
  {
    "slug": "ui-ux-designer",
    "name": "UI/UX Designer",
    "kurz": "UI/UX Designer",
    "icon": "PenTool",
    "bereich": "Produkt & Design",
    "title": "UI/UX Designer: Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein UI/UX Designer? Unterschied zwischen UI, UX und Product Design, Gehalt nach Erfahrung, Einstieg und Portfolio. Mit Zahlen für 2026.",
    "intro": [
      "UI/UX Designer sorgen dafür, dass digitale Produkte verständlich, angenehm und effizient zu bedienen sind. UX steht für User Experience, also das gesamte Erlebnis eines Nutzers mit einem Produkt. UI steht für User Interface, die sichtbare Oberfläche mit Farben, Schriften und Bedienelementen. In vielen Stellen werden beide Aufgaben zusammengefasst."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior",
          "jahre": "0–2 Jahre",
          "min": 40000,
          "max": 50000
        },
        {
          "label": "Mid-Level",
          "jahre": "3–5 Jahre",
          "min": 50000,
          "max": 65000
        },
        {
          "label": "Senior",
          "jahre": "6–10 Jahre",
          "min": 65000,
          "max": 82000
        },
        {
          "label": "Lead / Head of Design",
          "min": 80000,
          "max": 105000
        }
      ]
    }
  },
  {
    "slug": "agile-coach-scrum-master",
    "name": "Agile Coach / Scrum Master",
    "kurz": "Agile Coach / Scrum Master",
    "icon": "Workflow",
    "bereich": "Leitung & Organisation",
    "title": "Agile Coach & Scrum Master: Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein Scrum Master, was ein Agile Coach? Aufgaben, Zertifikate, Gehalt nach Erfahrung, Einstieg und Marktlage. Mit Zahlen für 2026.",
    "intro": [
      "Scrum Master und Agile Coaches helfen Teams und Organisationen, besser zusammenzuarbeiten und schneller Ergebnisse zu liefern. Der Scrum Master begleitet in der Regel ein oder zwei Teams im Alltag, der Agile Coach arbeitet mit mehreren Teams, Führungskräften und ganzen Bereichen an der Arbeitsweise."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior Scrum Master",
          "min": 48000,
          "max": 58000
        },
        {
          "label": "Scrum Master",
          "jahre": "3–5 Jahre",
          "min": 58000,
          "max": 75000
        },
        {
          "label": "Senior Scrum Master / Agile Coach",
          "min": 72000,
          "max": 92000
        },
        {
          "label": "Enterprise Coach / Transformation Lead",
          "min": 90000,
          "max": 115000
        }
      ]
    }
  },
  {
    "slug": "system-administrator",
    "name": "System Administrator",
    "kurz": "Systemadministrator",
    "icon": "Server",
    "bereich": "Cloud & Infrastruktur",
    "title": "Systemadministrator: Aufgaben, Gehalt, Einstieg 2026 | djiiga",
    "description": "Was macht ein Systemadministrator? Aufgaben, Gehalt nach Erfahrung, Berlin im Vergleich, Einstieg und der Weg in Cloud und DevOps. Mit Zahlen für 2026.",
    "intro": [
      "Systemadministratoren halten die IT eines Unternehmens am Laufen: Server, Netzwerke, Benutzerkonten, Arbeitsplätze, Backups. Wenn morgens alle Mitarbeitenden ihre E-Mails abrufen, auf gemeinsame Laufwerke zugreifen und sicher von zu Hause arbeiten können, steckt dahinter ihre Arbeit."
    ],
    "gehalt": {
      "stufen": [
        {
          "label": "Junior",
          "jahre": "0–2 Jahre",
          "min": 40000,
          "max": 50000
        },
        {
          "label": "Mid-Level",
          "jahre": "3–5 Jahre",
          "min": 48000,
          "max": 60000
        },
        {
          "label": "Senior",
          "jahre": "6–10 Jahre",
          "min": 58000,
          "max": 72000
        },
        {
          "label": "Teamleitung / Infrastruktur",
          "min": 70000,
          "max": 90000
        }
      ]
    }
  }
];
